import React from 'react'
import { connect } from 'react-redux'
import { friendListSet, removeFriend } from '../../../../../action/friend-list-actions'
import UserFollowing from '../../../../../lib/api/userFollowing'
import isNil from 'lodash/isNil'
// import { withStyles } from '@material-ui/core/styles'
// import Switch from '@material-ui/core/Switch'
import { withStyles } from '@mui/styles';
import Switch from '@mui/material/Switch';
import { setUserPreferenceState } from '../../../../../action/user-preferences'
import { userHasPro } from '../../../../../lib/util'
import { openModal } from '../../../../../action/positioned-modal-state'
import ConfirmRemoval from './unfollowPopup'
import FriendCard from './friendsListComponent'
import { infoWindowOpenAction } from '../../../../../action/infowindow-action'
import { friendsLocation, friendsLocationMapObj, removeFriendsLocationMapObj, locationClearTimeOut } from '../../../../../action/friends-location-action'
import { createInfoContent } from '../infoWindow'
import ImageUrl from '../../../../../../asset/Avatar_BaseMap-User_Default@1x.png'

const BaseMapSwitch = withStyles((theme) => ({
  root: {
    width: 32,
    height: 16,
    padding: 0,
    marginLeft: 5,
    marginRight: 5
  },
  thumb: {
    width: 16,
    height: 16
  },
  track: {
    backgroundColor: '#c1c0c0 !important'
  },
  switchBase: {
    padding: 0
  },
  checked: {
    transform: 'translateX(16px) !important'
  }
}))(Switch)

class FriendsList extends React.Component {
  constructor(props) {
    super(props)
    this.containerRef = React.createRef()
    this.toggleFriendLocations = this.toggleFriendLocations.bind(this)
    this.state = {
      friendLocations: props.friendLocations,
      unfollowPopup: false,
      selectedFriend: [],
      responseData: null,
      spinner: false
    }
    this.advanceMarker
    this.containerRef = React.createRef(); // Ref to track the scrolling container
    this.markersArray = []
    this.timeInterval = null
  }

  componentDidMount() {
    const { auth, user, friendListSet, friendLocations } = this.props
    if (!friendLocations) {
      this.removeMarker()
    }
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.friendList != this.props.friendList) {
      if (this.state.friendLocations) {
        this.setState({ responseData: this.props.friendList })
      }

    }
    // if (prevProps.friendsLocationState != this.props.friendsLocationState) {
    //   console.log('working')
    //   if (this.state.friendLocations) {
    //     console.log('working this.state.friendLocations')
    //     let fiterSharingLocationFriends = this.props.friendsLocationState.filter((item) => {
    //       return item
    //     })
    //     this.props.friendsLocation(fiterSharingLocationFriends)
    //     this.props.friendsLocationState.map((user) => {
    //       let position = { latitude: user.lat, longitude: user.lng }
    //       let color = '#589500'
    //       this.state.friendLocations && this.friendLocation(user.thumbnailUrl,
    //         color,
    //         position,
    //         user.userId,
    //         user)
    //     })
    //     this.props.friendsLocationMapObj(this.markersArray)
    //   }
    // }
  }

  componentWillUnmount() {
    if (this.advanceMarker) {
      this.advanceMarker.map = null
      this.advanceMarker = null
    }
    // this.removeMarker()
  }

  buildContent = (url, color) => {
    let colorMarker = color
    const content = document.createElement("div");
    content.classList.add("photo-property");
    content.innerHTML = `
      <div style="height: 30px; width: 30px; border: 2px solid ${colorMarker}; border-radius: 50%; overflow: hidden;margin-bottom: 5px; position: relative;background-color: ${colorMarker}">
      <img style="height: 30px; width: 30px; object-fit: cover; position: absolute; top: 0; left: 0;" src="${url ? url : ImageUrl}" alt="Image">
      </div>
      <div class="triangle-style-mouse-handler" style="border-top: 13px solid ${colorMarker}" ></div>
    `
    return content;
  }

  async fetchData() {
    const { auth, user, friendListSet } = this.props;
    this.setState({ spinner: true });

    UserFollowing.getFollowing({ token: auth.token, userId: user.id })
      .then(res => {
        this.setState({ responseData: res, spinner: false });
        friendListSet(res);
      })
      .catch(err => {
        console.error('Could not fetch friend list', user.id, err);
        this.setState({ spinner: false });
      });

    UserFollowing.locationSharing({ token: auth.token, userId: user.id })
      .then(res => {
        let fiterSharingLocationFriends = res.filter(item => item.sharingWithMe);
        this.props.friendsLocation(fiterSharingLocationFriends);
      })
      .catch(err => {
        console.error('Could not fetch friend list', user.id, err);
      });

    const timeInterval = setInterval(() => {
      UserFollowing.getFollowing({ token: auth.token, userId: user.id })
        .then(res => {
          this.setState({ responseData: res, spinner: false });
          friendListSet(res);
        })
        .catch(err => {
          console.error('Could not fetch friend list', user.id, err);
        });

      UserFollowing.locationSharing({ token: auth.token, userId: user.id })
        .then(res => {
          let fiterSharingLocationFriends = res.filter(item => item.sharingWithMe);
          this.props.friendsLocation(fiterSharingLocationFriends);
          this.props.friendsLocationState.map((user) => {
            let position = { latitude: user.lat, longitude: user.lng }
            let color = '#589500'
            this.state.friendLocations && this.friendLocation(user.thumbnailUrl,
              color,
              position,
              user.userId,
              user)
          })
        })
        .catch(err => {
          console.error('Could not fetch friend list', user.id, err);
        });
    }, 1000 * 60 * 0.2); // 2 minutes

    // Pass the interval to clear function
    this.props.locationClearTimeOut(timeInterval);
  }

  async closeInfoBox() {
    const { infoWindow } = this.props;
    if (infoWindow) {
      infoWindow.infoWindowFunction.close();
    }
  }

  friendLocation(imageUrl, imageBgColor, position, id, friendData) {
    const { mapReference, friendsLocationMapObjState, infoWindow, infoWindowOpenAction } = this.props;
    let openInfoWindow = null;
    const token = this.props.auth.token;
    const storeInfoBox = (value) => {
      infoWindowOpenAction(value);
    };
    const closeInfoBoxIn = async () => {
      await this.closeInfoBox();
    };

    const createMarkerFunction = async () => {
      const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");
      const markerOptions = {
        map: mapReference,
        position: { lat: position.latitude || 0, lng: position.longitude || 0 },
        content: this.buildContent(imageUrl, imageBgColor),
      };
      const advanceMarker = new AdvancedMarkerElement(markerOptions);
      this.markersArray.push({ mapObject: advanceMarker, friendId: id });
      // Attach the click listener to the marker
      advanceMarker.addListener('click', handleClick);
    };

    // Updated handleClick function to manage `infoWindow` updates
    const handleClick = () => {
      closeInfoBoxIn(); // Close any existing infoWindows
      const closeFunction = (infoWindow) => {
        openInfoWindow = infoWindow;
        openInfoWindow.close();
      };

      const updateInfoWindow = (value) => {
        openInfoWindow = value;
      };

      const dispatchFunction = (value) => {
        storeInfoBox(value);
      };

      // Create new or update infoWindow content with fresh references
      createInfoContent(
        {
          mapReference,
          // advanceMarker,
          infoWindow,
          openInfoWindow,
          friendData,
          token,
          location: { lat: position.latitude || 0, lng: position.longitude || 0 },
        },
        { closeFunction, updateInfoWindow },
        dispatchFunction
      );
    };

    // Check if the position exists and handle the marker accordingly
    if (position && this.state.friendLocations) {
      // const idExists = friendsLocationMapObjState.some(item => item.friendId === id);
      const existingFriend = friendsLocationMapObjState.find(item => item.friendId === id);
      const idExists = Boolean(existingFriend);
      if (!idExists && friendData.sharingWithMe
        // friendData.sharingLocationWithMe && friendData.sharingLocationWithThem
      ) {
        console.log('Creating new marker');
        createMarkerFunction();
      } else if (idExists &&
        !friendData.sharingWithMe
        // (!friendData.sharingLocationWithMe || !friendData.sharingLocationWithThem)
      ) {
        console.log('Removing existing marker');
        this.mapObjRemove(friendData);
      } else {
        if (existingFriend) {
          let updateMapObj = existingFriend && existingFriend.mapObject;
          // Update marker position and content with latest data

          updateMapObj.position = { lat: position.latitude, lng: position.longitude };
          updateMapObj.content = this.buildContent(imageUrl, '#589500');
          // Redefine handleClick inside this block to capture updated `friendData` and other state
          const handleClick = () => {
            closeInfoBoxIn(); // Close any existing infoWindows
            const closeFunction = (infoWindow) => {
              openInfoWindow = infoWindow;
              openInfoWindow.close();
            };
            const updateInfoWindow = (value) => {
              openInfoWindow = value;
            };
            const dispatchFunction = (value) => {
              storeInfoBox(value);
            };
            // Create new or update infoWindow content with fresh references
            createInfoContent(
              {
                mapReference,
                infoWindow,
                openInfoWindow,
                friendData, // Ensure latest `friendData` is passed
                token,
                location: { lat: position.latitude, lng: position.longitude },
              },
              { closeFunction, updateInfoWindow },
              dispatchFunction
            );
          };
          // Remove any existing click listener and reassign the updated handleClick function
          window.google.maps.event.clearListeners(updateMapObj, 'click');
          updateMapObj.addListener('click', handleClick); // Reattach listener with updated handleClick function
        }
      }
    }
  }

  mapObjRemove(friendData, shareWithMe) {
    const { friendsLocationMapObjState } = this.props;
    const updatedVal = friendsLocationMapObjState.filter(friendObj => {
      if (friendObj.friendId === friendData.id) {
        // Set the map to null
        friendObj.mapObject.map = null;
        // Return false to exclude this object from the updated array
        return false;
      }
      // Return true to include all other objects
      return true;
    });

    this.markersArray = this.markersArray.filter(marker => marker.friendId !== friendData.id);
    this.props.friendsLocationMapObj(updatedVal);
  }

  removeMarker() {
    this.props.friendsLocationMapObjState.map((item) => {
      let mapObject = item.mapObject
      mapObject.map = null
    })
    this.markersArray = []
    this.props.removeFriendsLocationMapObj()
  }

  toggleFriendLocations(e) {
    this.removeMarker()
    if (userHasPro(this.props.user)) {
      e.persist()
      const { setUserPreferenceState } = this.props
      setUserPreferenceState({ friendLocations: e.target.checked })
      this.setState({ friendLocations: e.target.checked }, () => {
        if (this.state.friendLocations) {
          let fiterSharingLocationFriends = this.props.friendsLocationState.filter((item) => { return item.sharingWithMe && item })
          // let fiterSharingLocationFriends = this.props.friendList.filter((item) => { return item.sharingLocationWithMe && item })
          this.props.friendsLocation(fiterSharingLocationFriends)
          this.props.friendsLocationState.map((user) => {
            let userLocation = { latitude: user.lat, longitude: user.lng }
            let color = '#589500'
            this.friendLocation(user.thumbnailUrl, color,
              userLocation,
              // { latitude: user.latitude, longitude: user.longitude },
              user.userId,
              user)
          })
          this.props.friendsLocationMapObj(this.markersArray)

        } else {
          this.removeMarker()
        }
      })
    }
  }

  removeFriend(friend) {
    this.props.removeFriend(friend)
    this.setState({ unfollowPopup: false })
  }

  render() {
    const { user, openModal, friendList } = this.props,
      { unfollowPopup, responseData, spinner } = this.state,
      style = {}
    if (this.containerRef.current !== null) {
      const bounds = this.containerRef.current.getBoundingClientRect()
      style.height = `calc(100vh - ${bounds.top + 5}px)`
    }

    return (
      <div>
        <div style={{ borderBottom: '1px solid gray', padding: '5px' }}>
          <div style={{
            marginBottom: '5px',
            height: '20px',
            display: 'flex',
            justifyContent: 'space-between'
          }}>
            <p style={{ float: 'left' }}>View Location(s) on Map {
              !userHasPro(user) ?
                <a style={{
                  display: 'inlineBlock',
                  color: '#589900',
                  textDecoration: 'underline',
                  cursor: 'pointer'
                }}
                  onClick={() => { openModal({ subInfo: true }) }}
                >Upgrade Now</a> : null
            }</p>
            <div className='friends-list-switch-container'>
              <span className='vertical-center' style={{ height: '14px' }}>Off</span>
              <BaseMapSwitch
                className='friends-list-switch'
                checked={this.state.friendLocations}
                onChange={(e) => { this.toggleFriendLocations(e) }}></BaseMapSwitch>
              <span className='vertical-center' style={{ height: '14px' }}>On</span>
            </div>
          </div>
          <div style={{ fontSize: '10px' }}>
            <p>- Friends must have Location Sharing Enabled (requires mobile phone)</p>
            <p>- PRO Subscription Required</p>
          </div>
        </div>
        <div style={{ height: style.height, overflowY: 'auto' }} className='friend-list-scroll' ref={this.containerRef}>
          {/* {responseData && responseData.map(friend => this.makeCard(friend))} */}
          {friendList && friendList.map(friend => (
            <FriendCard
              key={friend.id}
              user={friend}
              removeFriend={() => removeFriend(friend)}
              unfollowPopup={(user) => this.setState({ unfollowPopup: true, selectedFriend: user })}
              friendLocations={this.state.friendLocations}
            />
          ))}
        </div>

        {/* {responseData && (responseData.hasAfter || responseData.hasBefore) && <div className='friends-list-next-previous-container'>
          <button className='prev-button' style={{ backgroundColor: responseData.hasBefore ? 'green' : 'gray', cursor: responseData.hasBefore ? 'pointer' : 'not-allowed' }} onClick={() => responseData.hasBefore ? this.onPreviousHandler(responseData) : console.log('no prev')}>Previous</button>
          <button className='next-button' style={{ backgroundColor: responseData.hasAfter ? 'green' : 'gray', cursor: responseData.hasAfter ? 'pointer' : 'not-allowed' }} onClick={() => responseData.hasAfter ? this.onNextHandler(responseData) : console.log('no next')}>Next</button>
        </div>} */}

        {spinner && <div class="friends-loader"></div>}

        {unfollowPopup &&
          <ConfirmRemoval remove={() => this.removeFriend(this.state.selectedFriend)} userData={this.state.selectedFriend} cancel={() => { this.setState({ unfollowPopup: false }) }}></ConfirmRemoval>
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  friendList: state.friendList,
  user: state.user,
  friendLocations: state.userPreferences.friendLocations,
  mapReference: state.mapReference(),
  friendsLocationMapObjState: state.friendsLocationMapObj,
  friendsLocationState: state.friendsLocation,
  auth: state.auth,
  followers: state.followers,
  infoWindow: state.infoWindow,
})

const mapDispatchToProps = dispatch => ({
  openModal: data => { dispatch(openModal(data)) },
  friendListSet: list => { dispatch(friendListSet(list)) },
  removeFriend: friend => { dispatch(removeFriend(friend)) },
  setUserPreferenceState: pref => { dispatch(setUserPreferenceState(pref)) },
  friendsLocation: friends => { dispatch(friendsLocation(friends)) },
  friendsLocationMapObj: friends => { dispatch(friendsLocationMapObj(friends)) },
  removeFriendsLocationMapObj: () => { dispatch(removeFriendsLocationMapObj()) },
  locationClearTimeOut: (timeInterval) => { dispatch(locationClearTimeOut(timeInterval)) },
  infoWindowOpenAction: (payload) => dispatch(infoWindowOpenAction(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(FriendsList)